import styled from 'styled-components'

const TermsOfServiceAndPrivacyPolicyContainer = styled.div`
  text-align: center;
  color: ${props => props.theme.textColorPrimary};
  font-size: ${props => props.theme.fontSizeExtraExtraSmall};
  margin-top: auto;
  padding-top: 20px;
`

export default TermsOfServiceAndPrivacyPolicyContainer
